import { render, staticRenderFns } from "./CrmEmptyState.vue?vue&type=template&id=02054499&scoped=true"
import script from "./CrmEmptyState.vue?vue&type=script&lang=js"
export * from "./CrmEmptyState.vue?vue&type=script&lang=js"
import style0 from "./CrmEmptyState.vue?vue&type=style&index=0&id=02054499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02054499",
  null
  
)

export default component.exports